import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function  Mumbaitokonkandarshancabbooking() {



  const cardData = {
    keyword: " Mumbai to Konkan Darshan Cab Booking",

"headingDescription": "Royal Route Cab offers reliable and comfortable Mumbai to Konkan Darshan cab booking services, ensuring a smooth, safe, and scenic coastal journey for families, pilgrims, beach lovers, and group travelers. Whether you are planning a temple tour, beach vacation, village exploration, or a long Konkan circuit trip, our professional drivers and well-maintained vehicles provide a stress-free travel experience. The Mumbai to Konkan route spans along the beautiful Western coastline of Maharashtra, covering destinations like Ratnagiri, Ganpatipule, Dapoli, Alibaug, and Tarkarli depending on your customized itinerary. The journey distance varies from 300 km to 600+ km based on destinations chosen and offers breathtaking views of beaches, hills, mango orchards, and coastal highways. We offer flexible booking options including one-way trips, round trips, and complete Konkan Darshan tour packages with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and Tempo Travellers suitable for all types of travelers. With easy online booking and 24/7 customer support, Royal Route Cab is your trusted partner for Mumbai to Konkan travel.",

"topPlaces": [
  {
    "title": "Ganpatipule Beach & Temple",
    "description": "Ganpatipule is one of the most famous destinations in the Konkan region, known for its pristine beach and the Swayambhu Ganpati Temple located right on the shore. The golden sand, clean blue waters, and peaceful atmosphere make it a perfect blend of spirituality and relaxation. Visitors can enjoy beach walks, temple darshan, water sports, and stunning sunset views along the Arabian Sea coastline."
  },
  {
    "title": "Tarkarli Beach",
    "description": "Tarkarli Beach is famous for its crystal-clear waters and is one of the best destinations in Maharashtra for water sports like scuba diving and snorkeling. The beach offers white sand stretches, serene surroundings, and homestays that provide authentic Konkan hospitality. It is especially popular among adventure lovers and couples seeking peaceful coastal experiences."
  },
  {
    "title": "Dapoli Beach Belt",
    "description": "Dapoli is a beautiful coastal stretch often called 'Mini Mahabaleshwar of Konkan' due to its pleasant climate and greenery. It features multiple beaches like Murud, Ladghar, and Karde, offering dolphin spotting, beach camping, and peaceful sunset views. The region is ideal for long relaxing stays surrounded by nature and local Konkani culture."
  },
  {
    "title": "Alibaug Beaches",
    "description": "Alibaug is a popular weekend destination near Mumbai known for its clean beaches like Alibaug Beach, Nagaon Beach, and Kashid Beach. Visitors can enjoy water sports, beach resorts, and historical forts like Kolaba Fort. It is a perfect quick Konkan-style getaway with easy accessibility from Mumbai via road and ferry."
  },
  {
    "title": "Ratnagiri City & Beaches",
    "description": "Ratnagiri is a major coastal city in Konkan known for its scenic beaches, Alphonso mango orchards, and historic landmarks. Beaches like Ganeshgule and Mandvi offer peaceful surroundings and beautiful sunset views. The region is also famous for seafood, forts, and rich Marathi coastal culture."
  },
  {
    "title": "Sindhudurg Fort",
    "description": "Sindhudurg Fort is a historic sea fort built by Chhatrapati Shivaji Maharaj, located on an island off the Malvan coast. Surrounded by the Arabian Sea, it showcases strong Maratha naval architecture and offers a unique experience of history, adventure, and scenic boat rides to reach the fort."
  },
  {
    "title": "Harihareshwar Temple & Beach",
    "description": "Harihareshwar is a sacred coastal town known for its ancient Shiva temple and peaceful beach surroundings. It is often called the 'Dakshin Kashi' of Maharashtra and is ideal for spiritual visits combined with relaxing beach experiences along clean and less crowded shores."
  },
  {
    "title": "Murud-Janjira Fort",
    "description": "Murud-Janjira Fort is one of the strongest sea forts in India, located near Murud Beach. Known for its unconquered history, massive stone walls, and water-surrounded structure, it is accessible only by boat. Visitors enjoy ferry rides, fort exploration, and panoramic sea views."
  },
  {
    "title": "Kashid Beach",
    "description": "Kashid Beach is a stunning white sand beach known for its clear waters and peaceful environment. Surrounded by casuarina trees, it is perfect for relaxation, photography, and water sports. It is one of the cleanest and most scenic beaches in the Konkan belt."
  },
  {
    "title": "Malvan & Devbagh",
    "description": "Malvan and Devbagh are famous coastal destinations known for seafood, backwaters, scuba diving, and island views. Devbagh offers peaceful beaches and boat rides, while Malvan is known for its cultural richness and authentic Konkan cuisine experience."
  }
],







services: [
  {
    name: "Mumbai to Konkan Darshan Cab",
    description: "Mumbai to Konkan Darshan cab service offers a scenic coastal journey covering some of the most beautiful beaches, temples, and villages in the Konkan region. This tour is perfect for families, couples, and group travelers looking for a relaxing getaway. The route includes lush greenery, sea views, and peaceful destinations like Ganpatipule, Tarkarli, and Ratnagiri. Professional drivers ensure safe travel on coastal and ghat roads. Comfortable vehicles and flexible itineraries enhance the experience. It guarantees a memorable and refreshing Konkan trip."
  },
  {
    name: "Mumbai to Konkan Darshan Taxi",
    description: "Mumbai to Konkan Darshan taxi provides a convenient and comfortable travel option for exploring coastal Maharashtra. This service includes door-to-door pickup and flexible travel planning. Vehicles are well-maintained and driven by experienced chauffeurs. Ideal for family vacations and leisure travel. It ensures a smooth and enjoyable journey."
  },
  {
    name: "Mumbai to Konkan Tour Cab Service",
    description: "Mumbai to Konkan tour cab service is designed for multi-day travel across scenic coastal destinations. This service is ideal for travelers visiting beaches, forts, and temples in Konkan. Vehicles are maintained for long-distance journeys. Professional drivers ensure safe and smooth travel. Flexible routes and stopovers add convenience. It ensures a well-planned tour experience."
  },
  {
    name: "Mumbai to Konkan Taxi Service",
    description: "Mumbai to Konkan taxi service offers reliable intercity travel with a focus on comfort and safety. This service is suitable for tourists, families, and group travelers. Clean vehicles and experienced drivers ensure a pleasant journey. Flexible scheduling allows easy travel planning. It guarantees a stress-free trip."
  },
  {
    name: "Cab from Mumbai to Konkan Darshan",
    description: "Cab from Mumbai to Konkan Darshan provides a personalized travel experience with flexible stops along coastal routes. Travelers can explore beaches, temples, and local attractions at their own pace. This service is ideal for families and small groups. Professional drivers ensure safe travel. It offers a relaxed and scenic journey."
  },
  {
    name: "Taxi from Mumbai to Konkan Tour",
    description: "Taxi from Mumbai to Konkan tour offers a comfortable and efficient way to explore the coastal region. With experienced drivers and well-maintained vehicles, this service ensures smooth travel. Door-to-door pickup adds convenience. Suitable for short and extended trips. It ensures a reliable journey."
  },
  {
    name: "Mumbai to Konkan Cab Booking",
    description: "Mumbai to Konkan cab booking allows travelers to reserve their tour vehicle easily with flexible travel options. Customers can choose vehicle type, pickup location, and travel plan. Instant confirmation and transparent pricing ensure a hassle-free process. It simplifies trip planning."
  },
  {
    name: "Mumbai to Konkan Taxi Booking Online",
    description: "Mumbai to Konkan taxi booking online provides a quick and convenient way to plan your coastal trip. Customers can compare vehicles and pricing easily. Secure payment and instant confirmation enhance convenience. It ensures availability during peak holiday seasons."
  },
  {
    name: "Mumbai to Konkan Cab Price",
    description: "Mumbai to Konkan cab price varies based on vehicle type, travel duration, and tour package. Transparent pricing ensures no hidden charges. Budget-friendly and premium options are available. It helps travelers plan their trip efficiently. It ensures value-driven travel."
  },
  {
    name: "Mumbai to Konkan Taxi Fare",
    description: "Mumbai to Konkan taxi fare is designed to be competitive and affordable for multi-day coastal tours. Fare depends on car type and travel plan. Customers receive clear pricing details before booking. It ensures cost-effective travel."
  },
  {
    name: "Mumbai to Konkan One Way Cab",
    description: "Mumbai to Konkan one way cab is suitable for travelers planning a single destination visit along the Konkan coast. This service offers flexible travel options without return charges. Comfortable vehicles and experienced drivers ensure smooth journeys. It is ideal for customized travel plans."
  },
  {
    name: "Mumbai to Konkan Round Trip Taxi",
    description: "Mumbai to Konkan round trip taxi is ideal for complete travel packages with return journey included. This service is suitable for family vacations and group tours. Flexible schedules allow easy planning. Professional drivers ensure safe travel. It ensures convenience and comfort."
  },
  {
    name: "Mumbai to Konkan Innova Cab",
    description: "Mumbai to Konkan Innova cab is perfect for families and groups seeking spacious and comfortable travel. The vehicle offers ample seating and luggage space for long journeys. Ideal for coastal tours. Professional drivers ensure safety. It provides a premium travel experience."
  },
  {
    name: "Mumbai to Konkan Ertiga Cab",
    description: "Mumbai to Konkan Ertiga cab is suitable for small groups and families looking for an affordable yet comfortable ride. This vehicle offers good mileage and seating comfort. Ideal for budget-friendly travel. Drivers ensure smooth journeys. It ensures a pleasant experience."
  },
  {
    name: "Mumbai to Konkan Sedan Cab",
    description: "Mumbai to Konkan sedan cab is ideal for couples and small families seeking economical travel. Sedans offer smooth driving and comfort for long journeys. This option is widely preferred for its affordability. Professional drivers ensure safe travel. It is perfect for a relaxed journey."
  },
  {
    name: "Mumbai to Konkan SUV Taxi",
    description: "Mumbai to Konkan SUV taxi provides extra space and comfort for group travel across coastal and hilly roads. SUVs offer better performance and stability on long routes. This option is ideal for families and large groups. Drivers ensure safe and reliable travel. It delivers a comfortable experience."
  },
  {
    name: "Konkan Darshan Package from Mumbai",
    description: "Konkan Darshan package from Mumbai offers a complete travel plan covering major coastal destinations, beaches, temples, and forts. This package includes cab service, flexible itinerary, and comfortable vehicles. Ideal for families and group travelers. It ensures a well-organized and memorable trip."
  },
  {
    name: "Best Konkan Cab Service Mumbai",
    description: "Best Konkan cab service Mumbai ensures a premium travel experience with well-maintained vehicles and professional drivers. This service focuses on safety, comfort, and customer satisfaction. Multiple vehicle options are available for different needs. Transparent pricing builds trust. It guarantees a reliable and enjoyable coastal journey."
  }
],

tableData: [
  ["Mumbai to Konkan Darshan Cab", "Mumbai to Konkan Darshan Taxi"],
  ["Mumbai to Konkan Tour Cab Service", "Mumbai to Konkan Taxi Service"],
  ["Cab from Mumbai to Konkan Darshan", "Taxi from Mumbai to Konkan Tour"],
  ["Mumbai to Konkan Cab Booking", "Mumbai to Konkan Taxi Booking Online"],
  ["Mumbai to Konkan Cab Price", "Mumbai to Konkan Taxi Fare"],
  ["Mumbai to Konkan One Way Cab", "Mumbai to Konkan Round Trip Taxi"],
  ["Mumbai to Konkan Innova Cab", "Mumbai to Konkan Ertiga Cab"],
  ["Mumbai to Konkan Sedan Cab", "Mumbai to Konkan SUV Taxi"],
  ["Konkan Darshan Package from Mumbai", "Best Konkan Cab Service Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Complete Konkan Darshan Tour",
    WhyChoosedescription: "Royal Route Cabs offers a well-planned Mumbai to Konkan Darshan cab service covering beautiful destinations like Ganpatipule, Tarkarli, Ratnagiri, Sindhudurg, and more."
  },
  {
    WhyChooseheading: "Experienced Coastal Route Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in Konkan coastal routes and ghat sections, ensuring safe driving and smooth navigation throughout the journey."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear pricing including tolls, driver allowance, and complete trip cost with no hidden charges."
  },
  {
    WhyChooseheading: "Flexible Multi-Day Tour Packages",
    WhyChoosedescription: "We offer customizable 2 to 5 day Konkan Darshan tour packages based on your travel plan, destinations, and comfort."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and regularly cleaned to ensure a comfortable long-distance coastal travel experience."
  },
  {
    WhyChooseheading: "24/7 Pickup & Travel Flexibility",
    WhyChoosedescription: "Our cab services are available 24/7, allowing flexible departure from Mumbai for your Konkan Darshan trip."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options for Groups",
    WhyChoosedescription: "We provide sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for families and group travel."
  },
  {
    WhyChooseheading: "Trusted Konkan Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for Mumbai to Konkan Darshan cab bookings due to reliable service, professional drivers, and well-planned tours."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Konkan Darshan cab service?", answer: "Yes, Royal Route Cabs offers complete Konkan Darshan cab tour packages from Mumbai." },
  { question: "Which places are covered in Konkan Darshan?", answer: "Popular destinations include Ganpatipule, Tarkarli, Ratnagiri, Sindhudurg, Malvan, and nearby coastal locations." },
  { question: "How many days are required for Konkan Darshan?", answer: "Typically, 2 to 5 days are required depending on the number of places you want to visit." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 for flexible travel planning." },
  { question: "Which vehicles are available for this tour?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Can I customize the tour package?", answer: "Yes, we provide fully customizable Konkan tour plans based on your preferences." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we offer pickup from home, hotel, and airport anywhere in Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended, especially during holiday and tourist seasons." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Suresh Kadam",
    feedback: "Our Konkan Darshan trip from Mumbai with Royal Route Cabs was excellent. The journey was scenic, comfortable, and perfectly managed by the driver.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Madhavi Naik",
    feedback: "We enjoyed a hassle-free Konkan tour from Mumbai. Royal Route Cabs provided a clean cab and a polite driver who made the long journey very pleasant.",
    rating: 5
  }
];























  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Konkan Darshan Cab Booking",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-konkan-darshan-cab.jpg", // replace if needed
  "description": "Book Mumbai to Konkan Darshan cab with Royal Route Cabs for a scenic and comfortable coastal tour. Choose from sedan, SUV, Innova, and luxury cars for one-way and round-trip packages. Safe, reliable, and 24x7 service for Konkan travel.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "8000", // adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-konkan-darshan-cab-booking"
  }
};







  return (
    <div>
<Helmet>
  <title>Mumbai to Konkan Darshan Cab Booking | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Konkan Darshan cab with Royal Route Cabs. Enjoy scenic Konkan tour with sedan, SUV, Innova & luxury cars. Safe, comfortable & 24x7 available taxi service."
  />

  <meta
    name="keywords"
    content="mumbai to konkan darshan cab, mumbai to konkan darshan taxi, mumbai to konkan tour cab service, mumbai to konkan taxi service, cab from mumbai to konkan darshan, taxi from mumbai to konkan tour, mumbai to konkan cab booking, mumbai to konkan taxi booking online, mumbai to konkan cab price, mumbai to konkan taxi fare, mumbai to konkan one way cab, mumbai to konkan round trip taxi, mumbai to konkan innova cab, mumbai to konkan ertiga cab, mumbai to konkan sedan cab, mumbai to konkan suv taxi, konkan darshan package from mumbai, best konkan cab service mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/13.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitokonkandarshancabbooking;